import styled from 'styled-components';

const ButtonRow = styled.div`
	text-align: right;
	margin-top: 25px;
`;

export default ButtonRow;
